import script from "./myCertificate.vue?vue&type=script&setup=true&lang=js"
export * from "./myCertificate.vue?vue&type=script&setup=true&lang=js"

import "./myCertificate.vue?vue&type=style&index=0&id=5f70c51f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f70c51f"]])

export default __exports__